import { render, staticRenderFns } from "./CommentEditAlert.vue?vue&type=template&id=7796d569&scoped=true&"
import script from "./CommentEditAlert.vue?vue&type=script&lang=js&"
export * from "./CommentEditAlert.vue?vue&type=script&lang=js&"
import style0 from "./CommentEditAlert.vue?vue&type=style&index=0&id=7796d569&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796d569",
  null
  
)

export default component.exports